import { useTranslation } from "react-i18next";
import {useNavigate, useOutletContext} from "react-router-dom";
import React, {useEffect, useState} from "react";
import { RiderProfileLayoutContextInterface } from "../RiderProfileLayout";
import ImageInput from "../../../Components/ImageInput";
import {patrollerService} from "../../../Api/Services/PatrollerService";
import {useLoading} from "../../../Context/LoadingProvider";
import {useInfoModal} from "../../../Context/InfoModalProvider";
import CheckBtn from "../../../Components/CheckBtn";
import RadioBtn from "../../../Components/RadioBtn";

const QuestionerStep: React.FunctionComponent<any> = ({ setStep, setProgressStep }) => {
    const { t } = useTranslation();
    const {
        setSubTitle,
        rider,
        setShowProfileInfo,
    } = useOutletContext<RiderProfileLayoutContextInterface>();
    const navigate = useNavigate();
    const { startLoading, finnishLoading } = useLoading();
    const [questionerQuestions, setQuestionerQuestions] = useState<any[]>([]);
    const [questionerQuestionResults, setQuestionerQuestionResults] = useState<any[]>([]);
    const [currentQuestioneNumber, setCurentQuestionNumber] = useState<number>(0);
    const [currentImage, setCurrentImage] = useState<File[]>([]);
    const [skippedQuestions, setSkippedQuestions] = useState<any[]>([]);
    //const [showErrorMessages, setShowErrorMessages] = useState<boolean>(false);
    const { showInfo } = useInfoModal();
    const [errorType, setErrorType] = useState<null | 'required' | 'image' | 'number'>(null);




    useEffect(() => {
        setSubTitle();
    }, [t, setSubTitle]);

    setSubTitle(t('Action'));

    const fetchQuestions = () => {
        startLoading('fetch-questions');
        patrollerService
            .getQuestionerQuestions(rider?.vehicle)
            .then((questions) => setQuestionerQuestions(questions))
            .finally(() => {
                setProgressStep(5);
                finnishLoading('fetch-questions');
            });
    };

    useEffect(() => {
        fetchQuestions();
        setShowProfileInfo(false);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (questionerQuestions.length > 0) {
            // current = 3 (fix lépések) + (aktuális kérdés index + 1)
            setProgressStep(3 + currentQuestioneNumber + 1);
        }
    }, [currentQuestioneNumber, questionerQuestions.length, setProgressStep]);

    // questioner_answers:[
    //     {
    //         questionerQuestionId: int,
    //         answer: string|null,
    //         score: int|null,
    //         imageUrl: string|null,
    //     }
    // ]

    const getOptionNameForCurrentLanguage = (option: any) => {
        return option.name;
    }

    const getOptionNameForCurrentLanguageText = (option: any) => {
        const lang = localStorage.getItem("language") ?? "en";

        if (lang === "ar") {
            return option.name_ar ?? option.name;
        }

        return option.name;
    }

    const getQuestionForCurrentLanguage = (question: any) => {
        const lang = localStorage.getItem("language") ?? "en";

        if (lang === "ar") {
            return question.question_ar ?? question.question;
        }

        return question.question;
    }

    useEffect(() => {
        const questionerQuestionsResultsMap = [];

        for (let i = 0; i < questionerQuestions.length; i++) {
            questionerQuestionsResultsMap.push({
                questionerQuestionId: questionerQuestions[i].id,
                questionerQuestion: questionerQuestions[i],
                answer: questionerQuestions[i].type === 'MULTIPLE_CHOICE:MULTI' ? [] : null,
                score: null,
                imageUrl: [],
            });
        }

        setQuestionerQuestionResults(questionerQuestionsResultsMap);
    }, [questionerQuestions]);


    const handleNext = () => {

        const updatedSkippedQuestions: string[] = [];

        questionerQuestionResults.forEach((result, index) => {
            const question = questionerQuestions[index];
            if (!question) return;

            const options = question.options ?? [];
            const selectedOptions = Array.isArray(result.answer)
                ? options.filter((opt: any) => result.answer.includes(opt.name))
                : options.filter((opt: any) => opt.name === result.answer);

            selectedOptions.forEach((opt: any) => {
                if (opt.skip?.length > 0) {
                    updatedSkippedQuestions.push(...opt.skip.map((s: any) => s.toString()));
                }

                if (opt.jump && !updatedSkippedQuestions.includes(opt.jump.toString())) {
                    const currentOrder = parseInt(question.order);
                    const jumpOrder = parseInt(opt.jump);
                    for (let i = currentOrder + 1; i < jumpOrder; i++) {
                        updatedSkippedQuestions.push(i.toString());
                    }
                }
            });
        });

        setSkippedQuestions(updatedSkippedQuestions);
        let skippedQuestionsSync = [...updatedSkippedQuestions];

        setQuestionerQuestionResults(prevResults => {
            const newResults = [...prevResults];

            newResults.forEach((res, idx) => {
                const question = questionerQuestions[idx];
                if (!question) return;

                if (skippedQuestionsSync.includes(question.order.toString())) {
                    res.answer = question.type === 'MULTIPLE_CHOICE:MULTI' ? [] : null;
                    res.score = null;
                    res.imageUrl = [];
                }
            });

            return newResults;
        });

        if (
            questionerQuestions[currentQuestioneNumber].type === 'NUMBER' &&
            (questionerQuestionResults[currentQuestioneNumber].answer === null ||
                isNaN(Number(questionerQuestionResults[currentQuestioneNumber].answer)))
        ) {
            setErrorType('number');
            setTimeout(() => setErrorType(null), 5000);
            return;
        }

        if (
            (!questionerQuestionResults[currentQuestioneNumber].answer ||
                (Array.isArray(questionerQuestionResults[currentQuestioneNumber].answer) &&
                    questionerQuestionResults[currentQuestioneNumber].answer.length === 0)) &&
            questionerQuestionResults[currentQuestioneNumber].questionerQuestion.mandatory
        ) {
            setErrorType('required');
            setTimeout(() => setErrorType(null), 5000);
            return;
        }

        if (
            questionerQuestionResults[currentQuestioneNumber].imageUrl.length === 0 &&
            parseInt(questionerQuestionResults[currentQuestioneNumber].questionerQuestion.image_mandatory) === 1
        ) {
            setErrorType('image');
            setTimeout(() => setErrorType(null), 5000);
            return;
        }

        setCurrentImage([]);

        if (['MULTIPLE_CHOICE:SINGLE', 'MULTIPLE_CHOICE:MULTI'].includes(questionerQuestions[currentQuestioneNumber].type)) {
            let options = questionerQuestions[currentQuestioneNumber].options;
            if (!options) {
                setCurentQuestionNumber(currentQuestioneNumber + 1);
            }

            let currentOption = options.find(
                (x: any) => getOptionNameForCurrentLanguage(x) === questionerQuestionResults[currentQuestioneNumber].answer
            );

            if (currentOption && currentOption.score) {
                questionerQuestionResults[currentQuestioneNumber].score = parseInt(currentOption.score ?? '0');
            }

            if (questionerQuestions[currentQuestioneNumber].type === 'MULTIPLE_CHOICE:MULTI') {
                let currentOptions = options.filter((x: any) =>
                    questionerQuestionResults[currentQuestioneNumber].answer.includes(getOptionNameForCurrentLanguage(x))
                );

                for (let multiOption of currentOptions) {
                    questionerQuestionResults[currentQuestioneNumber].score += parseInt(multiOption.score ?? '0');
                    currentOption = multiOption;
                }
            }
        } else {
            questionerQuestionResults[currentQuestioneNumber].score =
                questionerQuestionResults[currentQuestioneNumber].answer !== '' &&
                questionerQuestionResults[currentQuestioneNumber].answer != null
                    ? questionerQuestions[currentQuestioneNumber].score
                    : 0;
        }

        let addedIndex = 1;
        let nextQuestion = questionerQuestions[currentQuestioneNumber + addedIndex] ?? null;
        while (nextQuestion && skippedQuestionsSync.includes(nextQuestion.order.toString())) {
            addedIndex++;
            nextQuestion = questionerQuestions[currentQuestioneNumber + addedIndex] ?? null;
        }

        if (nextQuestion) {
            setCurentQuestionNumber(currentQuestioneNumber + addedIndex);
            return;
        }

        if (currentQuestioneNumber + 1 < questionerQuestions.length) {
            setCurentQuestionNumber(currentQuestioneNumber + 1);
            return;
        }

        startLoading('questioner-verification');
        // @ts-ignore
        patrollerService.saveQuestionerData(rider.riderId, questionerQuestionResults).then(async () => {
            await patrollerService.finishCheckForRider(rider.riderId);
            showInfo(t("Rider check saved successfully!") as string).then(() => {
                navigate(`/rider/${rider.riderId}/profile`);
            });
        }).finally(() => {
            finnishLoading('questioner-verification');
        });
    };

    useEffect(() => {
        if (currentImage.length > 0){
            questionerQuestionResults[currentQuestioneNumber].imageUrl = currentImage[0];
            setQuestionerQuestionResults([...questionerQuestionResults]);
        }
        //eslint-disable-next-line
    }, [currentImage]);
    if (questionerQuestions.length === 0 || questionerQuestionResults.length === 0){
        return (
            <div className="text-center">
                {t("Loading...")}
            </div>
        );
    }
    return (
        <>
            {/*
            <div className="mb-4">
                {t("Survey Completion")}
            </div>
            */}

            {/*
            <div className="questions-progressbar">
                <div className="questions-progressbar__progress" style={{width: `${(currentQuestioneNumber) / questionerQuestions.length * 100}%`}}></div>
                <p className="questions-progressbar__text">
                    {Math.round((currentQuestioneNumber) / questionerQuestions.length * 100)}%
                </p>
            </div>
            */}

           
                

                <p className="heading mb-4">
                    {getQuestionForCurrentLanguage(questionerQuestions[currentQuestioneNumber])}
                </p>

                <div className="flex justify-center items-center w-full">
                    {questionerQuestions[currentQuestioneNumber]?.imageUrl !== '' &&  <img src={questionerQuestions[currentQuestioneNumber]?.imageUrl} className="mb-4" alt=""/>}
                </div>

                {
                    questionerQuestions[currentQuestioneNumber].type === 'YES_NO' && (
                        <div className="flex justify-center">
{/*
                            <label className="checkbox mb-4">
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        questionerQuestionResults[currentQuestioneNumber].answer = 'YES';
                                        setQuestionerQuestionResults([...questionerQuestionResults]);
                                    }}
                                    required
                                    checked={questionerQuestionResults[currentQuestioneNumber].answer === 'YES'}
                                />
                                <div className="checkbox__success-icon no-border bg-gray"></div>
                                <div className="checkbox__text">{t("Yes")}</div>
                            </label>
*/}
                            <CheckBtn
                                label={t("Yes")}
                                selected={questionerQuestionResults[currentQuestioneNumber].answer === 'YES'}
                                onChange={(e) => {
                                            questionerQuestionResults[currentQuestioneNumber].answer = 'YES';
                                            setQuestionerQuestionResults([...questionerQuestionResults]);
                                        }}
                                className="mb-4"
                            />
{/*
                            <label className="checkbox mb-4">
                                <input
                                    type="checkbox"
                                    onChange={(e) => {
                                        questionerQuestionResults[currentQuestioneNumber].answer = 'NO';
                                        setQuestionerQuestionResults([...questionerQuestionResults]);
                                    }}
                                    required
                                    checked={questionerQuestionResults[currentQuestioneNumber].answer === 'NO'}
                                />
                                <div className="checkbox__success-icon no-border bg-gray"></div>
                                <div className="checkbox__text">{t("No")}</div>
                            </label>
*/}
                            <CheckBtn
                                label={t("No")}
                                selected={questionerQuestionResults[currentQuestioneNumber].answer === 'NO'}
                                onChange={(e) => {
                                        questionerQuestionResults[currentQuestioneNumber].answer = 'NO';
                                        setQuestionerQuestionResults([...questionerQuestionResults]);
                                    }}
                                className="mb-4"
                            />

                        </div>
                    )
                }

                {
                    questionerQuestions[currentQuestioneNumber].type === 'TEXT' && (
                        <textarea
                            className="input-field"
                            value={questionerQuestionResults[currentQuestioneNumber].answer ?? ""}
                            onChange={(e) => {
                                questionerQuestionResults[currentQuestioneNumber].answer = e.target.value;
                                setQuestionerQuestionResults([...questionerQuestionResults]);
                            }}
                        />
                    )
                }

            {
                questionerQuestions[currentQuestioneNumber].type === 'NUMBER' && (
                    <input
                        className="input-field"
                        type="number"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={questionerQuestionResults[currentQuestioneNumber].answer ?? ""}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "");
                            questionerQuestionResults[currentQuestioneNumber].answer = val;
                            setQuestionerQuestionResults([...questionerQuestionResults]);
                        }}
                    />
                )
            }

                {
                    questionerQuestions[currentQuestioneNumber].type === 'MULTIPLE_CHOICE:MULTI' && (
                        <div>
                            {
                                questionerQuestions[currentQuestioneNumber].options && questionerQuestions[currentQuestioneNumber].options.map((option: any, index: number) => (
/*
                                    <label className="checkbox mb-4">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                if (questionerQuestionResults[currentQuestioneNumber].answer?.includes(getOptionNameForCurrentLanguage(option))) {
                                                    questionerQuestionResults[currentQuestioneNumber].answer = questionerQuestionResults[currentQuestioneNumber].answer.filter((x: string) => x !== getOptionNameForCurrentLanguage(option));
                                                } else {
                                                    questionerQuestionResults[currentQuestioneNumber].answer.push(getOptionNameForCurrentLanguage(option));
                                                }
                                                setQuestionerQuestionResults([...questionerQuestionResults]);
                                            }}
                                            required
                                            checked={questionerQuestionResults[currentQuestioneNumber].answer?.includes(getOptionNameForCurrentLanguage(option))}
                                        />
                                        <div className="checkbox__success-icon no-border bg-gray"></div>
                                        <div className="checkbox__text">{getOptionNameForCurrentLanguageText(option)}</div>
                                    </label>
*/
                                    <CheckBtn
                                        label={getOptionNameForCurrentLanguageText(option)}
                                        selected={questionerQuestionResults[currentQuestioneNumber].answer?.includes(getOptionNameForCurrentLanguage(option))}
                                        onChange={(e) => {
                                            if (questionerQuestionResults[currentQuestioneNumber].answer?.includes(getOptionNameForCurrentLanguage(option))) {
                                                questionerQuestionResults[currentQuestioneNumber].answer = questionerQuestionResults[currentQuestioneNumber].answer.filter((x: string) => x !== getOptionNameForCurrentLanguage(option));
                                            } else {
                                                questionerQuestionResults[currentQuestioneNumber].answer.push(getOptionNameForCurrentLanguage(option));
                                            }
                                            setQuestionerQuestionResults([...questionerQuestionResults]);
                                        }}
                                        className="mb-4"
                                    />

                                ))
                            }
                        </div>
                    )

                }
                
                {
                    questionerQuestions[currentQuestioneNumber].type === 'MULTIPLE_CHOICE:SINGLE' && (
                        <div>
                            {
                                questionerQuestions[currentQuestioneNumber].options && questionerQuestions[currentQuestioneNumber].options.map((option: any, index: number) => (
                                    <>
                                        {/*
                                        <label className="checkbox mb-4">
                                            <input
                                                type="checkbox"
                                                onChange={(e) => {
                                                    questionerQuestionResults[currentQuestioneNumber].answer = getOptionNameForCurrentLanguage(option);
                                                    setQuestionerQuestionResults([...questionerQuestionResults]);
                                                }}
                                                required
                                                checked={questionerQuestionResults[currentQuestioneNumber].answer === getOptionNameForCurrentLanguage(option)}
                                            />
                                            <div className="checkbox__success-icon no-border bg-gray"></div>
                                            <div className="checkbox__text">{getOptionNameForCurrentLanguageText(option)}</div>
                                        </label>
                                        */}

                                        <RadioBtn
                                            label={getOptionNameForCurrentLanguageText(option)}
                                            selected={questionerQuestionResults[currentQuestioneNumber].answer === getOptionNameForCurrentLanguage(option)}
                                            onSelect={(e) => {
                                                    questionerQuestionResults[currentQuestioneNumber].answer = getOptionNameForCurrentLanguage(option);
                                                    setQuestionerQuestionResults([...questionerQuestionResults]);
                                                }}
                                            className="mb-4"
                                        />
                                    </>
                                ))
                            }
                        </div>
                    )

                }
                {
                    questionerQuestions[currentQuestioneNumber].type === 'SHORT_TEXT' && (
                        <div>
                            <input
                                className="input-field mb-4"
                                value={questionerQuestionResults[currentQuestioneNumber].answer ?? ""}
                                onChange={(e) => {
                                    questionerQuestionResults[currentQuestioneNumber].answer = e.target.value;
                                    setQuestionerQuestionResults([...questionerQuestionResults]);
                                }}
                            />
                        </div>
                    )

                }
{/*}
                {questionerQuestions[currentQuestioneNumber]?.image_mandatory !== -1 &&
                    <div className="separator-line"></div> 
                }
*/}
                {questionerQuestions[currentQuestioneNumber]?.image_mandatory === 1 && 
                    <p className="text-light mb-4">{t("Confirmation picture is mandatory!")}</p>
                }

                {questionerQuestions[currentQuestioneNumber]?.image_mandatory !== -1 && 
                    <ImageInput
                        key={currentQuestioneNumber}
                        images={currentImage}
                        setImages={setCurrentImage}
                        title={t("Take a photo")}
                        infoText={t("Confirmation Photo")}
                        multiple={false}
                        required={questionerQuestions[currentQuestioneNumber]?.image_mandatory}
                    />}





            {/*{showErrorMessages && <div className="text-red mt-4">{t("Please choose an option!")}</div>}*/}
            {errorType === 'required' && <div className="text-red mt-4">{t("Please choose an option!")}</div>}
            {errorType === 'image' && <div className="text-red mt-4">{t("Confirmation picture is mandatory!")}</div>}
            {errorType === 'number' && <div className="text-red mt-4">{t("Please enter a valid number!")}</div>}

            <div className="flex gap-4 mt-8">
            
                <div className="flex-1">
                    {
                        currentQuestioneNumber > 0 &&
                        <button
                            type="submit"
                            className="button button--light"
                            onClick={() => {
                                if (currentQuestioneNumber > 0) {
                                    const skipped = skippedQuestions.map(q => q.toString());
                                    let previousIndex = currentQuestioneNumber - 1;

                                    while (
                                        previousIndex >= 0 &&
                                        skipped.includes(questionerQuestions[previousIndex].order.toString())
                                        ) {
                                        previousIndex--;
                                    }

                                    if (previousIndex >= 0) {
                                        setCurentQuestionNumber(previousIndex);

                                        const prevImage = questionerQuestionResults[previousIndex]?.imageUrl;

                                        if (prevImage instanceof File) {
                                            setCurrentImage([prevImage]);
                                        } else if (typeof prevImage === "string" && prevImage !== "") {
                                            fetch(prevImage)
                                                .then(res => res.blob())
                                                .then(blob => {
                                                    const file = new File([blob], "previous_image.jpg", { type: blob.type });
                                                    setCurrentImage([file]);
                                                })
                                                .catch(() => setCurrentImage([]));
                                        } else {
                                            setCurrentImage([]);
                                        }
                                    } else {
                                        console.warn("No previous question found");
                                    }
                                }
                            }}
                        >
                            {t("Back")}
                        </button>
                    }
                </div>

                <div className="flex-1">
                    <button
                        type="submit"
                        className="button"
                        onClick={() => {
                            handleNext();
                        }}
                    >
                        {t("Next")}
                    </button>
                </div>

            </div>
        </>
    );
};

export default QuestionerStep;